import React from "react";
import Breadcrumb from "./Breadcrumb";
import NotificationBell from "./NotificationBell";
import ProjectSwitcher from "./ProjectSwitcher";
import { useBreadcrumbStore } from "./../../../store/useBreadcrumbStore";

export default function Header({ onNewRun, onMenuClick }) {
  const items = useBreadcrumbStore((s) => s.items);
  //console.log("Header sees items:", items);
  return (
    <header className="wrapper__common__header">
      <button
        className="menu__toggle"
        onClick={onMenuClick}
        aria-label="Open menu"
      >
        <img src="/svg/toggle-menu.svg" alt="toggle Menu" />
      </button>
      <div className="wrapper__header__area">
        <Breadcrumb items={items} />
        {/* Outside .wrapper__right on purpose: that container is hidden below
          768px, and the project a run is scoped to has to stay switchable on
          a phone. */}
        <ProjectSwitcher />
      </div>
      {/* <div className="wrapper__right">
        <NotificationBell />
        <button
          className="wrapper__newRun common__btn common__blk__btn"
          onClick={onNewRun}
        >
          New Run
        </button>
      </div> */}
    </header>
  );
}
